import { createReducer } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';

export const siteLayoutReducerKey = 'siteLayoutReducer';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SiteLayoutState {}

const initialState: SiteLayoutState = {};

export const siteLayoutReducer = createReducer(initialState, onReset(initialState));
